export const MODAL_TYPES = {
  TEXT_MODAL: 'TEXT_MODAL',
  EDIT_ADDRESS_MODAL: 'EDIT_ADDRESS_MODAL',
  EXPLODE_FILE_MODAL: 'EXPLODE_FILE_MODAL',
};
